import type { FC, ReactElement, ReactNode } from "react"

import { AnimatePresence, motion, useReducedMotion } from "framer-motion"
import { useMeasure } from "react-use"
import type { UseMeasureResult } from "react-use/lib/useMeasure"

import { buildCssClassName } from "@/3514/utils"

type TProps = {
    children: ReactNode
    className?: string
    timeoutInMs?: number
}

const DynamicHeightContainer: FC<TProps> = ({ children, className = "", timeoutInMs = 300 }: TProps): ReactElement => {
    const [ref, { height }]: UseMeasureResult = useMeasure<HTMLDivElement>()

    const isMotionReduced: boolean = useReducedMotion()

    return (
        <AnimatePresence initial={false}>
            <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height, opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: isMotionReduced ? 0 : timeoutInMs / 1000, type: "tween", ease: "easeInOut" }}
                className="overflow-y-visible"
            >
                <div ref={ref} className={buildCssClassName({ [className]: className })}>
                    {children}
                </div>
            </motion.div>
        </AnimatePresence>
    )
}

DynamicHeightContainer.displayName = "DynamicHeightContainer"

export { DynamicHeightContainer }
